<template>
    <modal id="credit-card-payment-faile-modal" v-if="showModal" @close="handleClose()">
        <template #header>
            Update Your Billing Information (Payment Failed)
        </template>
        <template #body>
            <div class="w-full pt-4 pb-6">
                <div class="w-full" v-if="ccData">
                    <p>Kindly take a moment to review and update your billing information, as some of the credit cards on file have failed:</p>
                    <ul class="mt-2 pl-4">
                        <li v-for="cc in ccData">
                            An attempt to process payment for your subscription &laquo;<b>{{ cc.subscription }}</b>&raquo; on <b>{{ cc.last_payment_failure }}</b> has failed, using your
                            <span class="ml-1 inline-block xs:mb-1 text-gray-700 text-sm bg-red-100 border border-red-200 rounded-lg py-px px-1 leading-normal text-center cursor-pointer">{{ cc.card_type }} {{ cc.last_four }}</span>
                            <!-- <span class="ml-1 inline-block xs:mb-1 text-gray-700 text-sm bg-red-100 border border-red-200 rounded-lg py-px px-1 leading-normal text-center cursor-pointer">{{ cc.card_type }} {{ cc.last_four }}, Expires: {{ cc.expiration }}</span> -->
                        </li>
                    </ul>
                    <p class="mt-2">To ensure uninterrupted service for your account, please <a href="/profile" class="text-yellow-500 underline">click here to update this card or add a new card now</a> to avoid any interruptions.</p>
                </div>
                <div class="w-full" v-if="!ccData">
                    <p>Kindly take a moment to review and update your billing information as some of the credit cards on file has failed. It is important to ensure that your payment details are up to date to avoid any disruptions or issues with your account.</p>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="flex justify-center">
                <a type="button" href="/profile" class="btn btn-sm btn-yellow inline-flex mx-1">Update Card</a>
                <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="handleClose()">Close</div>
            </div>
        </template>
    </modal>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
    initialData: {
        type: [Object, Array],
        default: () => ({}),
        required: false,
    },
});

const ccData = ref(props.initialData || {});
const showModal = ref(false);

const handleClose = () => {
    showModal.value = false;
};

onMounted(() => {
    setTimeout(() => {
        showModal.value = true;
    }, 1000);
});
</script>

<style lang="scss">
#credit-card-payment-faile-modal {
    @apply text-left;

    .modal-container {
        width: 48rem;

        @screen xs {
            width: 100%;
        }

        ul {
            list-style: disc !important;
        }
    }
}
</style>
